import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export default function ExInvoicePage() {
  return (
    <div className="p-3" style={{ backgroundColor: "#f8f9fa" }}>
      {/* Header Bar */}
      <div className="d-flex justify-content-between align-items-center border-bottom px-3 py-2 bg-white shadow-sm">
        <h5 className="text-danger mb-0">View Invoices</h5>
        <div className="d-flex align-items-center gap-2">
          <div className="form-check m-0">
            <input
              className="form-check-input"
              type="checkbox"
              defaultChecked
              id="displayHeader"
            />
            <label className="form-check-label" htmlFor="displayHeader">
              Display Header
            </label>
          </div>
          <button className="btn btn-secondary btn-sm">Print</button>
          <button className="btn btn-success btn-sm">Collect Fee</button>
        </div>
      </div>

      {/* Invoice Container */}
      <div
        className="container bg-white border rounded p-0 mt-3 shadow-sm"
        style={{
          maxWidth: "95%",
          borderColor: "#dee2e6",
        }}
      >
        <div className="px-3 py-2">
          <p className="mb-1">hi parents</p>
        </div>

        {/* Student Info Section */}
        <div
          className="border mx-3 mb-3 p-3"
          style={{ borderColor: "#dcdcdc", fontSize: "15px" }}
        >
          <div className="row">
            <div className="col-md-6">
              <p className="mb-1">
                <strong>Admission No:</strong> fsdf35346
              </p>
              <p className="mb-1">
                <strong>Name:</strong> ASHUTOSE
              </p>
              <p className="mb-0">
                <strong>Grade:</strong> SEVENTH
              </p>
            </div>
            <div className="col-md-6">
              <p className="mb-1">
                <strong>Academic Year:</strong> 2020-2021
              </p>
              <p className="mb-1">
                <strong>Date:</strong> 10 Jun 2024
              </p>
              <p className="mb-1">
                <strong>Due Date:</strong> 2024-06-10
              </p>
              <p className="mb-0">
                <strong>Invoice No:</strong> IN-1785
              </p>
            </div>
          </div>
        </div>

        {/* Invoice Table */}
        <div
          className="mx-3 mb-3 border"
          style={{ borderColor: "#dcdcdc", borderWidth: "1px" }}
        >
          <table
            className="table mb-0"
            style={{
              fontSize: "15px",
              borderCollapse: "collapse",
              borderColor: "#dcdcdc",
            }}
          >
            <thead style={{ backgroundColor: "#f8f9fa" }}>
              <tr
                className="text-center align-middle"
                style={{ border: "1px solid #dcdcdc" }}
              >
                <th style={{ width: "5%", border: "1px solid #dcdcdc" }}>#</th>
                <th style={{ width: "45%", border: "1px solid #dcdcdc" }}>
                  Particulars
                </th>
                <th style={{ width: "25%", border: "1px solid #dcdcdc" }}>
                  Terms/Semester
                </th>
                <th style={{ width: "25%", border: "1px solid #dcdcdc" }}>
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  className="text-center align-top"
                  style={{ border: "1px solid #dcdcdc" }}
                >
                  1
                </td>

                {/* Particulars column with vertical line */}
                <td
                  className="align-top d-flex"
                  style={{
                    border: "1px solid #dcdcdc",
                    padding: "0",
                  }}
                >
                  {/* Left part – main heading */}
                  <div
                    style={{
                      width: "0px",
                      borderRight: "1px solid #dcdcdc",
                    }}
                  >
                    
                  </div>

                  {/* Right part – sub items */}
                  <div
                    style={{
                      width: "50%",
                      padding: "8px 10px",
                      marginLeft: "150px",
                      marginRight: "150px",
                    }}
                  > <strong>Arrears</strong>
                    <div className="text-muted">Arrear Discount</div>
                    <div className="text-muted">Additional Charges</div>
                    
                  </div>
                   <div
                    style={{
                      width: "0px",
                      borderRight: "1px solid #dcdcdc",
                    }}
                  >
                    
                  </div>
                </td>
                

                <td style={{ border: "1px solid #dcdcdc" }}></td>

                <td
                  className="align-top"
                  style={{ border: "1px solid #dcdcdc" }}
                >
                     <div
                    style={{
                      width: "0px",
                      padding: "5px",
                      marginLeft: "-20px",
                      height: "15vh",
                      borderRight: "1px solid #dcdcdc",
                    }}
                  >
                    
                  </div>
                    <div>
                  <div>$ 4000</div>
                  <div className="text-muted">$ 350</div>
                  <div className="text-muted">$ 50</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Totals Section */}
        <div
          className="mx-3 border"
          style={{ borderColor: "#dcdcdc", borderWidth: "1px" }}
        >
          <table
            className="table mb-0"
            style={{
              fontSize: "15px",
              borderCollapse: "collapse",
              borderColor: "#dcdcdc",
            }}
          >
            <tbody>
              {[
                ["Sub Total", "$ 4000"],
                ["Discount", "$ 350"],
                ["Tax/Additional Charges", "$ 50"],
                ["Grand Total", "$ 3700"],
                ["Paid Amount", "$ 0"],
                ["Balance", "$ 3700"],
              ].map(([label, value], index) => (
                <tr key={index}>
                  <td
                    style={{
                      width: "70%",
                      border: "1px solid #dcdcdc",
                    }}
                  ></td>
                  <td
                    style={{
                      border: "1px solid #dcdcdc",
                      fontWeight: "bold",
                    }}
                  >
                    {label}
                  </td>
                  <td
                    style={{
                      border: "1px solid #dcdcdc",
                    }}
                  >
                    {value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Balance Note */}
        <div className="px-3 py-2">
          <p className="fw-bold mb-1">
            Balance is Three thousand seven hundred $ Only.
          </p>
          <p className="mb-4">hai testing</p>
        </div>

        {/* Footer Print Button */}
        <div className="px-3 pb-3 text-end">
          <button className="btn btn-secondary btn-sm">Print</button>
        </div>
      </div>
    </div>
  );
}
